import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, Card, CardBody, CardFooter } from 'reactstrap';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import '../../css/components/Level/level.css';
import AxiosInstance from '../AxiosInstance/AxiosInstance';
import queryString from 'query-string';
import ListToTree from '../../common/listToTree/ListToTree';

var LTT = require('list-to-tree');

var Levelnodes = [];
var filterText = [];
let level;
let nodeid;

class ScorecardDetailLevel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      checked: [],
      expanded: [],
      latestChecked: [],
      Level: [],
      totalData: 10,
    };

    let params = this.props.params; // get query string params
    level = params == undefined ? null : params.level;
    nodeid = params == undefined ? null : params.nodeid;

    this.toggle = this.toggle.bind(this);
    this.onCheck = this.onCheck.bind(this);
    this.onExpand = this.onExpand.bind(this);
  }

  GetData() {
    AxiosInstance({
      method: "get",
      url: "tbGEN_m_Level/usp_tbGEN_m_Level_SelectAllEx_V12",
    })
      .then(response => {
        if (response != undefined && response.data != undefined) {
          var SCLevel = [];
          SCLevel = response.data.map(x => Object.assign({}, SCLevel, {
            levelID: x.levelID,
            name: x.name,
            parentID: x.parentID,
            parentName: x.parentName,
            key: x.key,
            parentKey: x.parentKey,
            authorised: x.Authorised,
            levelIndex: x.levelIndex,
            levelKey: x.levelIndex + "&" + x.levelID
          }))

          this.setState({
            Level:SCLevel,
          })

          var tree = new ListToTree.listToTree(SCLevel, {
            key_id: 'key',
            key_parent: 'parentKey'
          });

          var Lvl = JSON.stringify(tree);
        //  Lvl = Lvl.replace(/child/g, 'children');
          Lvl = Lvl.replace(/levelKey/g, 'value');
          Lvl = Lvl.replace(/name/g, 'label');
          var LvlTree = JSON.parse(Lvl);
     //     var LvlTree = ListToTree.refit_keys(tree);
          Levelnodes = LvlTree;

          //filter checked
          var checkedtree = [];

           checkedtree = SCLevel.filter(function (el) {
            //return (el.key == (level + nodeid))
            return (el.levelIndex == level && el.levelID == nodeid)
          });
          var checkedval = [];

          if (checkedtree.length > 0) {
            checkedval.push(checkedtree[0].levelKey)
          }

         // this.state.Level = SCLevel

          this.onCheck(checkedval);

          this.setState({ 
            checked: checkedval
           })

        }
      })
      .catch(function (error) {

      });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  onCheck(checked) {
    if (checked.length > 0) {
      this.setState({ checked });

      if (this.props.noCascade === true) {
        this.selectOneValue(checked);
      }

      filterText = [];

      for (var i = 0; i < checked.length; i++) {
        let filterLevel = this.state.Level;
        const filter = {
          key: checked[i],
        };

        filterLevel = filterLevel.filter(item => {
          for (let key in filter) {
            if (item[key] === undefined || item["levelKey"] != filter[key])
              return false;
          }
          return true;
        });

        // use var because state is async will delay
        filterText.push(filterLevel);

        //pass data back to parent 
        this.props.action(checked);
      }
    }
  }

  onExpand(expanded) {
    this.setState({ expanded });
  }

  // select only one value if nocascade === true
  selectOneValue(checked) {
    for (var i = 0; i < checked.length; i++) {
      for (var a = 0; a < this.state.latestChecked.length; a++) {
        if (checked[i] == this.state.latestChecked[a]) {
          checked.splice(i, 1);
        }
      }
    }
    this.setState({ latestChecked: checked });
  }

  componentDidMount() {
    this.GetData();
  }

  componentWillUnmount() {
    filterText = [];
  }

  render() {
    const { checked, expanded } = this.state;

    return (
      <div>
        <Card className="levelCard">
          <CardBody>
            <Table >
              <tbody className="levelCardTable" >
                {filterText.map((data, i) => {
                  var tr;
                  if (data.length > 0) {
                    tr =
                      <tr key={i}>
                        <td dangerouslySetInnerHTML={{ __html: data[0].name }} />
                      </tr>
                  }
                  return (
                    tr
                  )
                })}  
              </tbody>
            </Table>
          </CardBody>
          <CardFooter className="levelCardFooter">
            <Button color="form-action-sm-long" onClick={this.toggle} size="sm" className="float-right" data-langid="1851.01">Select Level</Button>
          </CardFooter>
        </Card>

        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop={true} size={'lg'}>
          <ModalHeader toggle={this.toggle}>Level</ModalHeader>
          <ModalBody className="LevelBody">
           
             
                <CheckboxTree
                  checked={checked}
                  expanded={expanded}
                  nodes={Levelnodes}
                  onCheck={this.onCheck}
                  onExpand={this.onExpand}
                  noCascade={this.props.noCascade}
                  showExpandAll
                />
            
          
          </ModalBody>
          <ModalFooter>
            <Button color="default" onClick={this.toggle}>Back</Button>
          </ModalFooter>
        </Modal>
      </div>
      )
              }
              }
export default ScorecardDetailLevel;

